import { load, save } from './storage';

/** Per-device preferences. Account/SIP details are never stored — they come from the server each load. */
export interface Prefs {
  inputDeviceId: string;
  outputDeviceId: string;
  ringDeviceId: string;
  sipTrace: boolean;
}

export const DEFAULT_PREFS: Prefs = {
  inputDeviceId: '',
  outputDeviceId: '',
  ringDeviceId: '',
  sipTrace: false,
};

const KEY = 'ngnphone.prefs';

export function loadPrefs(): Prefs {
  return load(KEY, DEFAULT_PREFS);
}

export function savePrefs(p: Prefs): void {
  save(KEY, p);
}
